import {JetView} from "webix-jet"; // Importing JetView from webix-jet for creating views
import {getColor} from "helpers/chartcolors"; // Importing a helper function to get chart colors
import {devConfig} from "../../../config/config"; // Importing development configuration

/**
 * MarketingView class extends JetView to create a marketing statistics view.
 */
export default class MarketingView extends JetView {
    /**
     * Configures the layout of the MarketingView.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService("locale")._; // Localization service for translating text
        var multiple_dataset = [ // Sample dataset for chart
            {"date": "2018-08-14", "clicks": 2}, 
            {"date": "2018-08-16", "clicks": 1}, 
            {"date": "2018-08-17", "clicks": 2}, 
            {"date": "2018-08-18", "clicks": 3}
        ];
        return {
            type: "clean", // Clean layout type
            rows: [
                {template: _("Estadisticas Marketing"), type: "header", css: "webix_header chart_header"}, // Header template
                {
                    view: "chart", // Chart view
                    height: 250, // Height of the chart
                    type: "line", // Line chart type
                    localId: "chart", // Local ID for referencing the chart
                    xAxis: {
                        template: "'#date#", // Template for x-axis labels
                        title:"Fecha", // Title for x-axis
                    },
                    yAxis: {
                        start: 0, // Starting value for y-axis
                        step: 10, // Step value for y-axis
                        title:"Valor" // Title for y-axis
                    },
                    legend: {
                        values: [ // Legend values for the chart
                            {text: "Clicks", color: "#1293f8"},
                            {text: "Visitas Links", color: "#66cc00"},
                            {text: "Registros", color: "#ff572d"}
                        ],
                        align: "right", // Legend alignment
                        valign: "middle", // Vertical alignment of legend
                        layout: "y", // Layout direction of legend
                        width: 100, // Width of the legend
                        margin: 8 // Margin around the legend
                    },
                    series: [ // Data series for the chart
                        {
                            value: "#clicks#", // Data value for clicks
                            item: {
                                borderColor: "#1293f8", // Border color for item
                                color: "#ffffff" // Item color
                            },
                            line: {
                                color: "#1293f8", // Line color
                                width: 3 // Line width
                            },
                            tooltip: {
                                template: "#clicks#" // Tooltip template for clicks
                            }
                        },
                        {
                            value: "#visits#", // Data value for visits
                            item: {
                                borderColor: "#66cc00", // Border color for item
                                color: "#ffffff" // Item color
                            },
                            line: {
                                color: "#66cc00", // Line color
                                width: 3 // Line width
                            },
                            tooltip: {
                                template: "#visits#" // Tooltip template for visits
                            }
                        },
                        {
                            value: "#register#", // Data value for registrations
                            item: {
                                borderColor: "#ff572d", // Border color for item
                                color: "#ffffff" // Item color
                            },
                            line: {
                                color: "#ff572d", // Line color
                                width: 3 // Line width
                            },
                            tooltip: {
                                template: "#register#" // Tooltip template for registrations
                            }
                        }
                    ]
                }
            ]
        };
    }

    /**
     * Initializes the MarketingView and sets up event listeners.
     */
    init() {
        const cur_user = this.getParam("user", true); // Get current user parameter
        var vthis = this; // Preserve context for event handlers

        // Event listener for marketing statistics updates
        this.on(this.app, "statisticsAgent:marketing", data => {
            vthis.$$("chart").clearAll(); // Clear existing chart data
            vthis.$$("chart").parse(data); // Parse new data into the chart
        });

        // Event listener for date range updates
        this.on(this.app, "statisticsAgent:date2", date => {
            var dateRange = date; // Store date range
            webix.ajax().headers({
                "Content-type": "application/json" // Set content type for AJAX request
            }).post(devConfig.geturlApi() + "Agent/GetMarketingStats", '{ "AgentId":' + cur_user + ', "FromDateLocal":"' + dateRange.FromDateLocal + '", "ToDateLocal":"' + dateRange.ToDateLocal + '"}', {
                error: function (text, data, XmlHttpRequest) {
                    webix.message("Error! "); // Display error message on failure
                },
                success: function (text, data, XmlHttpRequest) {
                    var data = JSON.parse(text); // Parse response data
                    vthis.$$("chart").clearAll(); // Clear existing chart data
                    vthis.$$("chart").parse(data.result.charts.MediaStat.records); // Parse new data into the chart
                }
            });
        });
    }
}

// FILE DOCUMENTED
